export default __webpack_public_path__ + "static/media/09AW2FEB66.28718605.jpg";